module.exports = __webpack_public_path__ + "static/media/sainsburys-web.cd503522.png";